'use client';

import { useState } from 'react';

import classnames from 'classnames';
import { TbCopy } from 'react-icons/tb';

import { IconButton } from '../icon-button';
import { Popover, PopoverContent, PopoverTrigger } from '../popover';
import type { CopyToClipboardProps } from './CopyToClipboard.types';

import styles from './CopyToClipboard.module.scss';

function CopyToClipboard({
  style,
  className,
  children,
  label = 'Copied!',
  testId = 'ui-copy-to-clipboard',
  icon,
  size = 'xs',
  value,
}: CopyToClipboardProps) {
  const [open, setOpen] = useState(false);

  const textToCopy = value || children?.toString() || '';

  return (
    <div
      style={style}
      className={classnames(
        styles['copy-to-clipboard'],
        styles[`copy-to-clipboard--${size}`],
        className,
      )}
      data-testid={testId}
    >
      {children}
      <Popover
        placement="top"
        open={open}
        onOpenChange={setOpen}
        closeAnimation="fadeOut"
      >
        <PopoverTrigger asChild={true}>
          <IconButton
            icon={icon || <TbCopy />}
            size={size}
            aria-label="Copiar al portapapeles"
            style={{ color: 'inherit' }}
            onClick={() => {
              setOpen((v) => !v);
              navigator.clipboard.writeText(textToCopy);

              setTimeout(() => {
                setOpen(false);
              }, 2000);
            }}
          />
        </PopoverTrigger>
        <PopoverContent>
          <span className={styles['copy']}>{label}</span>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export { CopyToClipboard };
